import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCursor01Filled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.14328 2.80979C4.89234 2.70521 4.64604 2.60255 4.44056 2.53753C4.25778 2.47969 3.87627 2.36873 3.46602 2.50166C3.00842 2.64993 2.64968 3.00866 2.50141 3.46626C2.36848 3.87652 2.47944 4.25802 2.53728 4.4408C2.60231 4.64628 2.70496 4.89258 2.80955 5.14351L8.34677 18.4344C8.46016 18.7067 8.56916 18.9684 8.67403 19.1692C8.76312 19.3399 8.96397 19.7102 9.36952 19.9062C9.81389 20.121 10.3355 20.1034 10.7644 19.8592C11.1558 19.6364 11.3313 19.2534 11.4087 19.0772C11.4998 18.8697 11.591 18.6012 11.6858 18.3219L13.0098 14.424L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L14.4241 13.0099L18.3217 11.6861C18.601 11.5912 18.8695 11.5001 19.0769 11.409C19.2531 11.3316 19.6361 11.1561 19.859 10.7646C20.1032 10.3357 20.1207 9.81413 19.906 9.36976C19.7099 8.96422 19.3396 8.76336 19.169 8.67427C18.9682 8.56941 18.7064 8.46041 18.4342 8.34702L5.14328 2.80979Z",
		fill: "currentColor"
	})
});
export default SvgCursor01Filled;
